export const headerConfig = {
  headerTitle: 'Missing Information',
  headerDescription: 'List of Missing Information',
  refreshButton: {
    id: 'refresh',
    label: 'Refresh',
    icon: 'RefreshIcon',
  },
};
